'use client';

import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const BannerBlogs: React.FC = () => {
  const { t } = useTranslation('pages');

  return (
    <>
      <Container>
        <Breadcrumb
          list={[
            { title: t('home.home'), href: routes.home.url },
            { title: t('blogs.news'), href: routes.blogs.url },
          ]}
        />
        <PublicPageHeading title={t('blogs.news')} />
      </Container>
    </>
  );
};
export default BannerBlogs;
